export const SITE_ORIGIN = 'https://www.epiqcase.com';
export const OG_IMAGE = `${SITE_ORIGIN}/epiqcase-product.webp`;

const home = {
    title: 'EpiQCase – Auvi-Q Case That Sticks to Your Phone | $15.99',
    description:
        'A case that holds your Auvi-Q epinephrine auto-injector on the back of your phone, so you never leave it behind. $15.99, free shipping, 30-day money-back guarantee.',
    canonicalPath: '/',
};

export const pages = {
    '/': home,
    '/Home': home,
    '/About': {
        title: 'Why I Created EpiQCase | EpiQCase',
        description:
            'Max lives with severe allergies and created EpiQCase so an Auvi-Q stays on the phone he already carries. The quick-release design is there when he needs it.',
        canonicalPath: '/About',
    },
    '/Purchase': {
        title: 'Buy EpiQCase | $15.99, Free Shipping',
        description:
            '$15.99 · Free shipping · 30-day money-back guarantee · Auvi-Q not included. EpiQCase attaches to the back of your phone and fits all Auvi-Q auto-injectors.',
        canonicalPath: '/Purchase',
    },
    '/Purchase/success': {
        title: 'Order Confirmation | EpiQCase',
        description:
            'Your EpiQCase order confirmation. Stripe emails a receipt when payment is complete.',
        canonicalPath: '/Purchase/success',
    },
    '/PrivacyPolicy': {
        title: 'Privacy Policy | EpiQCase',
        description:
            'EpiQCase uses the Meta pixel, Stripe Checkout, and Brevo to run this site, take orders, and send the free carry guide. This site does not create customer accounts.',
        canonicalPath: '/PrivacyPolicy',
    },
    '/guide': {
        title: 'Free Guide: 7 Ways to Carry Epinephrine (EpiPen, Auvi-Q, neffy) | EpiQCase',
        description:
            'This guide is free. Enter your email and EpiQCase will send 7 ways to carry epinephrine (EpiPen, Auvi-Q, neffy).',
        canonicalPath: '/guide',
    },
};

export function absoluteUrl(pathname) {
    if (pathname === '/') {
        return `${SITE_ORIGIN}/`;
    }
    return `${SITE_ORIGIN}${pathname}`;
}

export function pageForPath(pathname) {
    return pages[pathname] || {
        title: 'Page not found | EpiQCase',
        description: 'That page is not on EpiQCase.',
        canonicalPath: pathname || '/',
    };
}
